export default "__VITE_ASSET__Ob0YmXAV__"